import { createChannelManagementInstance } from '../api-instance';
import type { TRequestOptions } from '../types';

export interface WildberriesConnectRequest {
  token: string;
  name?: string;
}

export interface WildberriesConnectResponse {
  status: 'ready';
}

export const connectWildberries = (
  channelId: string,
  data: WildberriesConnectRequest,
  options?: TRequestOptions
): Promise<WildberriesConnectResponse> =>
  createChannelManagementInstance<WildberriesConnectResponse>(
    {
      url: `/api/v1/channels/${encodeURIComponent(channelId)}/wildberries/connect`,
      method: 'POST',
      data,
    },
    options
  );

export const disconnectWildberries = (
  channelId: string,
  options?: TRequestOptions
): Promise<void> =>
  createChannelManagementInstance<void>(
    {
      url: `/api/v1/channels/${encodeURIComponent(channelId)}/wildberries/disconnect`,
      method: 'POST',
      data: {},
    },
    options
  );
